import $ from 'jquery';

export const defaultTierToLabelMapping = {
    'ANONYMOUS': 'Become a Member',
    'EMAIL': 'Upgrade',
    'PRINT': 'Upgrade'
};

export const MEMBERSHIP_CTA_BASE_URL = window.initStore && window.initStore.env && window.initStore.env.CRO_MEMBERSHIP_CTA_BASE_DOMAIN || '';
export const ANONYMOUS_TIER_URL = window.initStore && window.initStore.env && window.initStore.env.CRO_PAYWALL_ANONYMOUS_TIER_URL || '';

export default class MembershipUtils {

    /**
     * Returns true if user has paywall
     */
    static isPaywallTier() {
        return window.CRUserInfo && !window.CRUserInfo.hasAtLeastMembershipTier('DIGITAL');
    }

    /**
     * Hides the jQuery element(s) based on provided mapping
     *
     * @param tierToHideElementsMapping user tier to jQuery elements to hide mapping
     */
    static hideCtaElement(tierToHideElementsMapping) {
        if (!tierToHideElementsMapping || !window.CRUserInfo) return;

        (tierToHideElementsMapping[window.CRUserInfo.getTier()] || $()).hide();
    }

    /**
     * Changes the text of given jQuery element(s) based on current user tier and Membership mapping
     *
     * @param $ctaElement jQuery element
     * @param tierToLabelMapping custom user tier to label mapping
     */
    static changeCtaElementText($ctaElement, tierToLabelMapping) {
        if (!$ctaElement || !window.CRUserInfo) return;
        const mapping = tierToLabelMapping || defaultTierToLabelMapping;

        $ctaElement.each(function() {
            const ctaLabelText = mapping[window.CRUserInfo.getTier()];
            if (ctaLabelText) {
                $(this).text(ctaLabelText);
            }
        });
    }

    /**
     * Changes the HTML markup of given jQuery element(s) based on current user tier and Membership mapping
     *
     * @param $ctaElement jQuery element
     * @param tierToHTMLMapping custom user tier to HTML markup mapping
     */
    static changeCtaElementHTML($ctaElement, tierToHTMLMapping) {
        if (!$ctaElement || !tierToHTMLMapping || !window.CRUserInfo) return;

        $ctaElement.each(function() {
            const ctaHTML = tierToHTMLMapping[window.CRUserInfo.getTier()];
            if (ctaHTML) {
                $(this).html(ctaHTML);
            }
        });
    }

    /**
     * Changes the URL of given jQuery element(s) based on current user tier
     * If URL contains request params they will be attached to the new URL without changes.
     *
     * @param $ctaElement jQuery element
     */
    static changeCtaElementUrl($ctaElement) {
        if (!$ctaElement || !window.CRUserInfo) return;

        const MEMBER_CTA = CRUserInfo.getMemberCta && CRUserInfo.getMemberCta() || '/join';
        const MEMBER_CTA_URL = `${MEMBERSHIP_CTA_BASE_URL}${MEMBER_CTA}`;
        const URL_PARAM_SEPARATOR = '?';

        $ctaElement.each(function() {
            const URL_TOKENS = $(this).attr('href').split(URL_PARAM_SEPARATOR);
            URL_TOKENS[0] = MEMBER_CTA_URL;
            $(this).attr('href', URL_TOKENS.join(URL_PARAM_SEPARATOR));
        });
    }

    /**
     * Add style class of given jQuery element(s) based on current user tier
     *
     * @param $ctaElement jQuery element
     * @param tierToStyleClassMapping custom user tier to style class
     */
    static addCtaElementStyleClass($ctaElement, tierToStyleClassMapping) {
        if (!$ctaElement || !tierToStyleClassMapping || !window.CRUserInfo) return;

        $ctaElement.addClass(tierToStyleClassMapping[window.CRUserInfo.getTier()]);
    }

}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/Membership/index.js